<template>
    <div>

        <transition name="fade">
            <div class="animation" ref="animation" :style="{maxWidth: width + 'px', maxHeight: height + 'px'}" v-show="loadReady"></div>
        </transition>

    </div>
</template>

<script>

    import lottie from 'lottie-web';

    export default {
        props: {
            loop: {
                type: Boolean,
                default: true
            },
            autoplay: {
                type: Boolean,
                default: true
            },
            name: {
                type: String,
                default: 'animation'
            },
            width: {
                type: Number,
                default: 100
            },
            height: {
                type: Number,
                default: 100
            },
        },
        data() {
            return {
                loadReady: false
            }
        },
        methods: {
            initAnimation() {

                let animation = {
                    container: this.$refs['animation'],
                    renderer: 'svg',
                    loop: this.loop,
                    autoplay: this.autoplay,
                    animationData: require('../../../public/animations/' + this.name + '.json')
                }

                this.animation = lottie.loadAnimation(animation);

            }
        },
        mounted() {

            setTimeout(() => {
                this.initAnimation();
                this.loadReady = true;
            }, 200);

        }
    }

</script>

<style lang="scss" scoped>

    .animation {
        // max-height: 200px !important;
    }

</style>